import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ServiceCategoryApi } from '../api/servicecategory.api';
import { switchMap, map } from 'rxjs/operators';

import { ServiceCategoryData, ServiceCategory } from '../../../interfaces/masters/servicecategory' ;
@Injectable()
export class ServiceCategoryService extends ServiceCategoryData {

    constructor(private api: ServiceCategoryApi) {
      super();
    }
  
  
    list(url: string): Observable<ServiceCategory[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<ServiceCategory>{
        return this.api.getById(url);
    }
  
    create(url: string, data:ServiceCategory): Observable<ServiceCategory[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:ServiceCategory): Observable<ServiceCategory> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }

    listsubcategory(url: string): Observable<any[]> {
      return this.api.list(url);
    }
  }
  